// extracted by mini-css-extract-plugin
export default {"administration-block":"styles_administration-block__dBguc","label":"styles_label__ORtDQ","autocomplete-margin":"styles_autocomplete-margin__mBanU"};